__webpack_require__.p = "https://ta-ops-tax-lot-fe.securitize.io/";